<template lang="pug">
#tempContain
  .title 加签
  .tempNode(v-if="hasTempNode")
      .success √ 已加签（{{ tempNode.flowNodeName || "未命名" }}）
      el-button(type="text" icon="el-icon-close" @click="handleCancelTmpNode") 取消加签
  .tempNode(v-else)
    span.blank 未添加加签节点
    el-button(type="text" icon="el-icon-plus" @click="openTemNode") 加签
  .tempList(v-if="tempFormBoolean")
    .tempTop
      span 添加节点(加签)
      i.el-icon-close(@click="tempFormBoolean = false")
    el-form(:model="node" ref="tempForm" size="mini" :rules="rules" label-width="90px" label-position="top" )
      el-form-item(label="节点名称" prop="nodeName")
        el-input(v-model="node.nodeName" size="small")
      el-form-item(label="处理人" prop="assigneeList")
        template(#label)
          span.itemLabel 处理人
          i.el-icon-circle-plus.addStyleApprove(title="选择人员" @click.stop="openAssPerson")
        userItem(ref="userItem" :userList="node.assigneeList" @deleteUser="deleteUser")
        //- userItem(ref="userItem" :userList="node.assigneeList" @deleteUser="deleteUser" v-if="node.assigneeList.length>0")
        //- el-button.addPeople(icon="el-icon-plus" size="small" type="primary" circle title="选择人员" @click="openAssPerson")
        .tips 提示：节点有多个处理人时，需要每个人都通过，节点才能完成
      el-form-item
        el-button(@click="tempFormBoolean=false" size="small") 取 消
        el-button(type="primary" @click="handleSubmit" size="small") 确 定
</template>

<script>
import flowService from "@/CommonDP/service/flow-service";
import { openMember, openH5Member } from "@/CommonDP/components/chooseMember/leftCom.js";
import userItem from "@/CommonDP/components/chooseMember/userItem.vue";
import { getApprove } from "@/CommonDP/components/processComponents/flowNewConfig/mapStore.js";

export default {
  components: { userItem },
  props: {
    uuid: { type: String, default: "" },
    source: { type: String, default: "pc" }
  },
  data () {
    return {
      allowAddNode: 0, // 0 没有加签
      nodeDef: {},
      hasTempNode: false, // 是否已经加签
      tempNode: {},
      tempFormBoolean: false,
      node: {
        nodeName: "",
        assigneeList: []
      },
      rules: {
        nodeName: [{ required: true, message: "请输入节点名称", trigger: "change" }],
        assigneeList: [{ required: true, message: "请选择处理人", trigger: "change" }]
      }
    };
  },
  computed: {
    nodeList() {
      return getApprove(this.uuid)?.getFlowNodeDtoList();
    },
    flowNodeId() {
      // nodeStatus:0：拒绝 1：同意 2：审批中 3：发起 4：再发起 5：撤销
      return this.nodeList.find(e => e.nodeStatus === "2").flowNodeId;
    },
    codePri() {
      return ['User'];
    }
  },
  mounted () {
    this.queryAddedNode();
  },
  methods: {
    // 查询是否已经加签
    async queryAddedNode() {
      const res = await flowService.queryNextTempNode(this.flowNodeId);
      this.tempNode = res.data || {};
      this.hasTempNode = !!this.tempNode.flowNodeId;
    },
    // 查询是否有加签节点
    async checkCanAddNode() {
      const res = await flowService.queryNodeDef(this.flowNodeId);
      this.nodeDef = res.data || {};
      this.allowAddNode = res.data?.allowAddNode || 0;
    },
    async openAssPerson() {
      const props = {
        filterOneself: false,
        codePri: this.codePri,
        usersList: this.node.assigneeList
      };
      const val = this.source !== "h5" ? await openMember(props) : await openH5Member(props);
      this.node.assigneeList = val;
    },
    openTemNode() {
      this.node.nodeName = "";
      this.node.assigneeList = [];
      this.tempFormBoolean = true;
    },
    deleteUser(user) {
      this.node.assigneeList = this.node.assigneeList.filter(e => e.userId !== user.userId);
    },
    // async userSelected(val) {
    //   this.node.assigneeList = [...this.node.assigneeList, ...val];
    // },
    handleSubmit() {
      this.$refs.tempForm.validate((valid) => {
        if (valid) {
          this.submit();
        }
      });
    },
    async submit() {
      const params = {
        lastFlowInstanceNodeId: this.flowNodeId,
        nodeName: this.node.nodeName,
        assigneeList: this.node.assigneeList
      };
      await flowService.addTempNode(params);
      this.$success("操作成功");
      this.queryAddedNode();
      this.tempFormBoolean = false;
    },

    // 取消加签
    async handleCancelTmpNode() {
      this.$confirm(`认取消并删除加签的节点吗？?`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        await flowService.deleteTmpNode(this.tempNode.flowNodeId);
        this.$success("取消成功");
        this.tempNode = {};
        this.hasTempNode = false;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 加签
    handleAddNode() {
      this.tempFormBoolean = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.title{
  line-height: 40px;
  font-size: 14px;
}
.tempNode{
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  .success{
    color: #08a134;
  }
  .blank{
    margin-left: 5px;
  }
  .el-button{
    margin-left: 5px;
  }
}
.tempList{
  width: 100%;
  padding: 5px 10px;
  background-color: #F7F9FF;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  .tempTop{
    width: 100%;
    height: 40px;
    padding: 0 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px dashed #ccc;
    span{
      font-size: 14px;
      font-weight: 600;
    }
    i{
      cursor: pointer;
    }
  }
}
.tips {
  // margin-left: 5px;
  color: #888;
  font-size: 0.8em;
}
.itemLabel{
  font-size: 14px;
  line-height: 28px;
}
.addStyleApprove{
  margin-left: 5px;
  font-size: 18px;
  line-height: 28px;
  color: var(--theme-color);
  cursor: pointer;
}
</style>
